// cantieri-costi-api.js — amm-v3 (A5, ondata 32): parte PURA della vista interna
// "Costi per cantiere" (pagina 'cantieri-costi' — aggregato read-only per
// cantiere, raggiunta dalla pagina Cantieri), testabile sotto node (contract
// test server/src/lib/amm-v3-cantieri-costi.test.js).
//
// PRINCIPI (rito A1..A4/proc-v3, spike o27 §2.2/§2.3):
//  - TESTI VERBATIM dal v1 (admin-module.js, renderCantieriCosti r.4277-4333):
//    il contract test pinna OGNI stringa di CC_TEXTS sul sorgente v1.
//  - VISTA DI SOLA LETTURA: nessun modale, nessuna scrittura. Le righe arrivano
//    GIÀ aggregate dal server (cantieri.aggregato): il v3 le mostra, non le
//    ricalcola. Le uniche funzioni pure qui sono testi + risoluzione anno.
//  - STATO CONDIVISO col v1: anno su AMM.cantieriCostiAnno (r.4279-4280) —
//    flip di flag senza perdite.
//  - DELEGHE: renderPage (seam + navigazione "‹ Cantieri" + anno prev/next),
//    fmtEur2 (€), toast (errore export). ZERO modali (nessun bypass di render).
//  - MAI 'nav:badge' o canali nuovi da client/src/amm-v3/**.

import { apiPathFn } from './api.js';

export const CC_DELEGATED_METHODS = [
  'renderPage',          // il seam stesso (wrap) + navigazione Cantieri/anno
  'renderCantieriCosti', // la vista v1 wrappata (drift guard: rename ⇒ rosso)
  'toast',               // esito export fallito (stesso canale del v1)
  'fmtEur2',             // formattazione € (unica fonte: v1)
];

export const CC_API_PATHS = [
  'cantieri.aggregato',  // GET /cantieri/aggregato?anno= (sola lettura)
  'export.download',     // Esporta CSV ('cantieri', anno)
];

// ---- TESTI VERBATIM dal v1 (pinnati dal contract test) ----
export const CC_TEXTS = {
  title: 'Costi per cantiere',
  sub: 'anno di competenza · trasferte = voci busta categoria "trasferta"; veicoli/polizze/crediti = collegati e attivi',
  back: '‹ Cantieri',
  exportCsv: 'Esporta CSV',
  colCantiere: 'Cantiere',
  colTrasferte: 'Trasferte €',
  colVeicoli: 'Veicoli',
  colPolizze: 'Polizze',
  colCrediti: 'Crediti',
  // empty (r.4292): 'Nessun dato per il ' + anno + ' (…)'
  emptyPre: 'Nessun dato per il ',
  emptySuf: ' (nessuna voce trasferta, veicolo, polizza o credito con o senza cantiere).',
  // error box v1 (r.4287)
  errorePre: 'Errore nel caricamento: ',
  exportFallito: 'Export fallito: ',
  // nome fisso del gruppo cantiere_id null (già valorizzato dal backend)
  dash: '—',
};

// messaggio vuoto — QUIRK v1 replicato (r.4292): include l'anno
export function emptyMessage(anno) {
  return CC_TEXTS.emptyPre + anno + CC_TEXTS.emptySuf;
}

// ---- STATO condiviso col v1 ----
// Risolve l'anno effettivo (r.4279-4280): AMM.cantieriCostiAnno o anno corrente.
// Write-through su AMM (parità di stato col v1).
export function risolviAnno(A) {
  const anno = A.cantieriCostiAnno || new Date().getFullYear();
  A.cantieriCostiAnno = anno;
  return anno;
}

// ---- LETTURA dati (composizione v1 r.4284): cantieri.aggregato(anno).
// Errore avvolto col prefisso VERBATIM del v1 (r.4287). ----
export async function readCantieriCosti(win, anno) {
  try {
    const righe = await apiPathFn(win, 'cantieri.aggregato').call(null, anno);
    return righe || [];
  } catch (e) {
    throw new Error(CC_TEXTS.errorePre + (e && e.message ? e.message : e));
  }
}

// ---- AZIONI e DELEGHE (stessi punti del v1) ----
// Navigazione "‹ Cantieri" (r.4323-4326): click sulla voce sidebar se esiste,
// altrimenti renderPage('cantieri') — STESSA logica del v1.
export function vaiCantieri(win) {
  const navEl = win.document.querySelector('.amm-link[data-page="cantieri"]');
  if (navEl) navEl.click();
  else win.AMM.renderPage('cantieri');
}
// Export CSV (r.4329-4332): vista 'cantieri', anno visualizzato.
export function esportaCsv(win, anno) { return apiPathFn(win, 'export.download').call(null, 'cantieri', anno); }
